// Calor VID Manual Issue L, February 2022 — Section 10 (page 265).
// Torque is by valve/fitting TYPE, not by tank type code.
// Values are brass valves into steel bosses.

export const VID_DOCUMENT = {
  title: 'Calor VID Manual',
  issue: 'L',
  date: 'February 2022',
  torquePage: 265,
};

export const TORQUE_TABLE = {
  combo: {
    label: 'Combo valves',
    nm: 200,
    orientationTurns: 1,
    note: 'Orient with the POL alignment tool so the regulator pipe runs parallel with the vessel axis past the tank lug.',
  },
  filler_5: {
    label: '5-in-line filler',
    nm: 200,
    orientationTurns: 1,
    note: '',
  },
  vapour_5: {
    label: '5-in-line vapour offtake',
    nm: 60,
    orientationTurns: 1,
    note: '',
  },
  cl_34: {
    label: '5-in-line ¾″ NPT check lock',
    nm: 60,
    orientationTurns: 0,
    note: '',
  },
  cl_114: {
    label: '5-in-line 1¼″ NPT check lock',
    nm: 130,
    orientationTurns: 0,
    note: 'After fitting and before evacuating or gas charging, check the internal closure moves freely and is not jammed.',
  },
  cl_cap: {
    label: 'Check lock cap on combo and 5-in-line',
    nm: 20,
    orientationTurns: null,
    note: '',
  },
  float: {
    label: 'Float gauge screws',
    nm: 7,
    orientationTurns: 0,
    note: 'Tighten evenly so the gasket and gauge head are level, with an even gap. Flat rubber gaskets only — not O-rings.',
  },
  rva: {
    label: 'Relief valve adaptor (525, 535, 545, or 1¼″ NPT × M36 European)',
    nm: 130,
    orientationTurns: 0,
    note: 'After fitting and before evacuating or gas charging, check the internal closure moves freely and is not jammed.',
  },
  rv: {
    label: 'Relief valve into adaptor with bonded seal (Calor 25-series, M36 & M45)',
    nm: 70,
    orientationTurns: 0,
    note: '',
  },
  fllg: {
    label: '¼″ NPT fixed liquid level gauge',
    nm: 30,
    orientationTurns: 1,
    note: 'One turn for bleed-hole orientation.',
  },
  steel_npt: {
    label: 'Steel-to-steel taper NPT (e.g. excess flow to vessel, ball valve to excess flow)',
    nm: null,
    orientationTurns: null,
    note: 'Up to and including 2″: hand tight then 3 complete turns. Over 2″: hand tight then 2 complete turns. Further tightening to orient is permitted. Unscrewing to orient is not permitted.',
  },
};

export const JOINTING_NOTES = [
  'Torque values are for brass valves into steel bosses.',
  'Fit all valves using PTFE tape to BS EN 751-3 type G (0.1 mm thick) directly on the valve thread, over-coated with non-hardening sealant to BS EN 751-2.',
  'The vessel must be at ambient temperature before any valves are fitted.',
];
